import type React from "react";

/**
 * InfoField — par "label + value" usado em painéis laterais e drawers
 * (TaskInfoPanel, KbDetail sidebar, etc).
 *
 * Substitui o pattern inline de 2 divs com `wf-hand-note` em todos os
 * lugares que mostram propriedades de uma entidade.
 */

export function InfoField({
  label,
  children,
  style,
}: {
  label: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <div style={style}>
      <div
        className="wf-hand-note"
        style={{ fontSize: 11, marginBottom: 2 }}
      >
        {label}
      </div>
      <div>{children}</div>
    </div>
  );
}
